module.exports = __webpack_public_path__ + "img/knewidea0.83fe33ba.jpg";